import React from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'

const useStyles = makeStyles(() => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 0',
    borderBottom: '1px solid var(--color-neutral-100)',
    fontSize: '12px',
    cursor: 'pointer',
    '&:last-child': { borderBottom: 'none' },
    '&:hover': { backgroundColor: 'var(--color-neutral-050)' }
  },
  methodBadge: {
    padding: '1px 5px',
    borderRadius: '3px',
    fontSize: '10px',
    fontWeight: 700,
    backgroundColor: 'var(--color-primary-050)',
    color: 'var(--color-primary-700)',
    fontFamily: 'var(--font-mono, monospace)',
    flexShrink: 0
  },
  url: {
    flex: 1,
    color: 'var(--color-neutral-800)',
    fontFamily: 'var(--font-mono, monospace)',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0
  },
  meta: {
    display: 'flex',
    gap: '6px',
    flexShrink: 0,
    alignItems: 'center'
  },
  statusBadge: {
    fontSize: '10px',
    fontWeight: 600
  },
  mockedTag: {
    padding: '0 4px',
    borderRadius: '2px',
    fontSize: '10px',
    fontWeight: 600,
    backgroundColor: 'var(--color-primary-050)',
    color: 'var(--color-primary-600)'
  },
  duration: {
    fontSize: '10px',
    color: 'var(--color-neutral-400)'
  }
}))

function RequestRow ({ request, onClick }) {
  const classes = useStyles()
  return (
    <div className={classes.row} onClick={onClick}>
      <span className={classes.methodBadge}>{request.method}</span>
      <span className={classes.url}>{request.url}</span>
      <div className={classes.meta}>
        <span
          className={classes.statusBadge}
          style={{ color: request.status < 300 ? 'var(--color-success-600)' : 'var(--color-danger-600)' }}
        >
          {request.status}
        </span>
        {request.mocked && <span className={classes.mockedTag}>mock</span>}
        {request.durationMs != null && (
          <span className={classes.duration}>{request.durationMs}ms</span>
        )}
      </div>
    </div>
  )
}

RequestRow.propTypes = {
  request: PropTypes.shape({
    method: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired,
    mocked: PropTypes.bool,
    durationMs: PropTypes.number
  }).isRequired,
  onClick: PropTypes.func
}

export default RequestRow
